import defineMessages from "../../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    title1: {
        id: "intro.rhytSorting.1.title",
    },
    title2: {
        id: "intro.rhytSorting.2.title",
    },
    title3: {
        id: "intro.rhytSorting.3.title",
    },
    title4: {
        id: "intro.rhytSorting.4.title",
    },
    description1: {
        id: "intro.rhytSorting.1.description",
    },
    description2: {
        id: "intro.rhytSorting.2.description",
    },
    description3: {
        id: "intro.rhytSorting.3.description",
    },
    description4: {
        id: "intro.rhytSorting.4.description",
    },
});

export default messages;
